const DebugConfig = {
  useFixtures: false,
  ezLogin: false,
}
export default DebugConfig
